<script>import Swatches from "../../../components/legend/Swatches.svelte";
import { scaleOrdinal } from "d3";
export let plotDefinitions;
$:
  swatchLabels = plotDefinitions.map((definition) => definition.properties.title);
$:
  swatchColors = plotDefinitions.map((definition) => definition.properties.colors[0].formatHex());
</script>

<div style="display:inline-block; margin-top:1rem;">
  <Swatches scale={scaleOrdinal(swatchLabels, swatchColors)} type={"circle"} />
</div>
